import PropTypes from "prop-types";
import React from "react";
import { Outlet } from "react-router-dom";

const RouteWithLayout = ({ layout: Layout, children }) => {
  return <Layout>{children || <Outlet />}</Layout>;
};

RouteWithLayout.propTypes = {
  layout: PropTypes.elementType.isRequired,
  children: PropTypes.node,
};

export default RouteWithLayout;
